export default __webpack_public_path__ + "static/media/closeModal.c30803ba.svg";